export const FORM_APP_DEF_ID = '225dd912-7dea-4738-8688-4b8c6955ffc2';
export const FORM_APP_WIDGET_ID = '371ee199-389c-4a93-849e-e35b8a15b7ca';
export const BLOG_APP_DEF_ID = '14bcded7-0066-7c35-14d7-466cb3f09103';
